import styled from "styled-components";

export const StyledShedule = styled.div`
  .small-input {
    display: inline-flex;
    width: 76px;
  }

  .small-input-group {
    margin-left: 10px;
    margin-right: 10px;
  }
`;

export const Cell = styled.div<{ top?: string }>`
  position: ${({ top }) => (top === undefined ? "initial" : "relative")};
  top: ${({ top }) => (top === undefined ? "0px" : top)};
  display: flex;
  align-items: center;
`;

export const Inline = styled.div<{ width?: string }>`
  display: inline-flex;
  align-items: center;
  width: ${({ width }) => (width === undefined ? "auto" : width)};
`;

export const VerticalSpace = styled.div<{ height: string }>`
  height: ${({ height }) => `${height}px`};
`;

export const Space = styled.span`
  width: 5px;
`;

export const OneTimeWrapper = styled.span`
  position: relative;
  top: 5px;
  margin-left: 10px;
`;

export const Row = styled.div<{ top?: string }>`
  top: ${({ top }) => (top === undefined ? "0px" : top)};
  position: ${({ top }) => (top === undefined ? "inherit" : "relative")};
  display: flex;
  align-items: center;
  flex-grow: 1;
  margin-bottom: 10px;
  width: 100%;
`;

export const NumberWrapper = styled.div`
  max-width: 55px;
  min-width: 55px;
`;
